/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} One_Off_SuffixInputs */

const en_one_off_suffix = /** @type {(inputs: One_Off_SuffixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`one-time purchase`)
};

const id_one_off_suffix = /** @type {(inputs: One_Off_SuffixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`one-time purchase`)
};

const ms_one_off_suffix = /** @type {(inputs: One_Off_SuffixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`one-time purchase`)
};

const ca_one_off_suffix = /** @type {(inputs: One_Off_SuffixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`one-time purchase`)
};

const cs_one_off_suffix = /** @type {(inputs: One_Off_SuffixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`one-time purchase`)
};

const da_one_off_suffix = /** @type {(inputs: One_Off_SuffixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`one-time purchase`)
};

const de_one_off_suffix = /** @type {(inputs: One_Off_SuffixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`one-time purchase`)
};

const et_one_off_suffix = /** @type {(inputs: One_Off_SuffixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`one-time purchase`)
};

const es_one_off_suffix = /** @type {(inputs: One_Off_SuffixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`one-time purchase`)
};

const fr_one_off_suffix = /** @type {(inputs: One_Off_SuffixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`one-time purchase`)
};

const hr_one_off_suffix = /** @type {(inputs: One_Off_SuffixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`one-time purchase`)
};

const it_one_off_suffix = /** @type {(inputs: One_Off_SuffixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`one-time purchase`)
};

const lv_one_off_suffix = /** @type {(inputs: One_Off_SuffixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`one-time purchase`)
};

const lt_one_off_suffix = /** @type {(inputs: One_Off_SuffixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`one-time purchase`)
};

const hu_one_off_suffix = /** @type {(inputs: One_Off_SuffixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`one-time purchase`)
};

const nl_one_off_suffix = /** @type {(inputs: One_Off_SuffixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`one-time purchase`)
};

const nb_one_off_suffix = /** @type {(inputs: One_Off_SuffixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`one-time purchase`)
};

const pl_one_off_suffix = /** @type {(inputs: One_Off_SuffixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`one-time purchase`)
};

const pt_one_off_suffix = /** @type {(inputs: One_Off_SuffixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`one-time purchase`)
};

const ro_one_off_suffix = /** @type {(inputs: One_Off_SuffixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`one-time purchase`)
};

const sk_one_off_suffix = /** @type {(inputs: One_Off_SuffixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`one-time purchase`)
};

const sl_one_off_suffix = /** @type {(inputs: One_Off_SuffixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`one-time purchase`)
};

const fi_one_off_suffix = /** @type {(inputs: One_Off_SuffixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`one-time purchase`)
};

const sv_one_off_suffix = /** @type {(inputs: One_Off_SuffixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`one-time purchase`)
};

const vi_one_off_suffix = /** @type {(inputs: One_Off_SuffixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`one-time purchase`)
};

const tr_one_off_suffix = /** @type {(inputs: One_Off_SuffixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`one-time purchase`)
};

const el_one_off_suffix = /** @type {(inputs: One_Off_SuffixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`one-time purchase`)
};

const bg_one_off_suffix = /** @type {(inputs: One_Off_SuffixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`one-time purchase`)
};

const ru_one_off_suffix = /** @type {(inputs: One_Off_SuffixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`one-time purchase`)
};

const sr_one_off_suffix = /** @type {(inputs: One_Off_SuffixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`one-time purchase`)
};

const uk_one_off_suffix = /** @type {(inputs: One_Off_SuffixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`one-time purchase`)
};

const ka_one_off_suffix = /** @type {(inputs: One_Off_SuffixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`one-time purchase`)
};

const hi_one_off_suffix = /** @type {(inputs: One_Off_SuffixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`one-time purchase`)
};

const th_one_off_suffix = /** @type {(inputs: One_Off_SuffixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`one-time purchase`)
};

const ko_one_off_suffix = /** @type {(inputs: One_Off_SuffixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`one-time purchase`)
};

const zh_tw_one_off_suffix = /** @type {(inputs: One_Off_SuffixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`one-time purchase`)
};

const ja_one_off_suffix = /** @type {(inputs: One_Off_SuffixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`one-time purchase`)
};

/** @type {(inputs: One_Off_SuffixInputs) => LocalizedString} */
const zh_one_off_suffix = en_one_off_suffix;

/**
* | output |
* | --- |
* | "one-time purchase" |
*
* @param {One_Off_SuffixInputs} inputs
* @param {{ locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }} options
* @returns {LocalizedString}
*/
export const one_off_suffix = /** @type {((inputs?: One_Off_SuffixInputs, options?: { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<One_Off_SuffixInputs, { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_one_off_suffix(inputs)
	if (locale === "ms") return ms_one_off_suffix(inputs)
	if (locale === "ca") return ca_one_off_suffix(inputs)
	if (locale === "cs") return cs_one_off_suffix(inputs)
	if (locale === "da") return da_one_off_suffix(inputs)
	if (locale === "de") return de_one_off_suffix(inputs)
	if (locale === "et") return et_one_off_suffix(inputs)
	if (locale === "es") return es_one_off_suffix(inputs)
	if (locale === "fr") return fr_one_off_suffix(inputs)
	if (locale === "hr") return hr_one_off_suffix(inputs)
	if (locale === "it") return it_one_off_suffix(inputs)
	if (locale === "lv") return lv_one_off_suffix(inputs)
	if (locale === "lt") return lt_one_off_suffix(inputs)
	if (locale === "hu") return hu_one_off_suffix(inputs)
	if (locale === "nl") return nl_one_off_suffix(inputs)
	if (locale === "nb") return nb_one_off_suffix(inputs)
	if (locale === "pl") return pl_one_off_suffix(inputs)
	if (locale === "pt") return pt_one_off_suffix(inputs)
	if (locale === "ro") return ro_one_off_suffix(inputs)
	if (locale === "sk") return sk_one_off_suffix(inputs)
	if (locale === "sl") return sl_one_off_suffix(inputs)
	if (locale === "fi") return fi_one_off_suffix(inputs)
	if (locale === "sv") return sv_one_off_suffix(inputs)
	if (locale === "vi") return vi_one_off_suffix(inputs)
	if (locale === "tr") return tr_one_off_suffix(inputs)
	if (locale === "el") return el_one_off_suffix(inputs)
	if (locale === "bg") return bg_one_off_suffix(inputs)
	if (locale === "ru") return ru_one_off_suffix(inputs)
	if (locale === "sr") return sr_one_off_suffix(inputs)
	if (locale === "uk") return uk_one_off_suffix(inputs)
	if (locale === "ka") return ka_one_off_suffix(inputs)
	if (locale === "hi") return hi_one_off_suffix(inputs)
	if (locale === "th") return th_one_off_suffix(inputs)
	if (locale === "ko") return ko_one_off_suffix(inputs)
	if (locale === "zh") return zh_one_off_suffix(inputs)
	if (locale === "zh-tw") return zh_tw_one_off_suffix(inputs)
	if (locale === "ja") return ja_one_off_suffix(inputs)
	return en_one_off_suffix(inputs)
});